module.exports = __webpack_public_path__ + "img/EVRLogo - Dark.56ac4167.png";